import React, { useState } from "react";
import {
  RootContainer,
  MyWalletContainer,
  MyWalletLabel,
  ReloadIcon,
} from "./MyWallet.style";
import {
  ArrowRightLine,
  AddCircleFill,
  UploadFill,
  WalletFill,
  BalanceLoading,
} from "@assets";
import { useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginAlert, saveUser } from "@redux/auth/authSlice";
import { getFormattedNumber } from "@utils";
import { TOPUP_LK } from "@constants";
import { useTranslation } from "react-i18next";
import Lottie from "react-lottie";
import { api } from "@api";
import { localStorage } from '@utils';

const WalletButton = ({ label, icon, onClick }) => {
  return (
    <MyWalletContainer light={true} onClick={onClick}>
      <MyWalletLabel light={true}>{label}</MyWalletLabel>
      {icon}
    </MyWalletContainer>
  );
};

const MyWallet = ({ width, back }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { main_balance, bonus, is_in_game, can_exit_check } = useSelector(
    (state) => state.auth.user
  );
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);

  const goToWallet = () => {
    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WALLET}`, {
      state: {
        back,
      },
    });
  };

  const handleTopUpClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const handleWithdrawClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const checkIsLoggedIn = () => {
    if (!isLoggedIn) {
      dispatch(setOpenLoginAlert(true));
    }
    return isLoggedIn;
  };

  const checkExit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!loading) {
      setLoading(true);
      api
        .checkExit()
        .then(({ user }) => {
          // save user to redux
          dispatch(saveUser(user));
          // save user to localstorage
          localStorage.setUser(user);
        })
        .catch(() => { });
    }
  }

  return (
    <RootContainer width={width}>
      <MyWalletContainer
        onClick={goToWallet}
        style={{
          justifyContent: "space-between",
          minWidth: "100px",
        }}
      >
        <WalletFill />
        <MyWalletLabel>
          {is_in_game ? (
            <Lottie
              options={{
                animationData: BalanceLoading,
              }}
              width={32}
              height={16}
            />
          ) : (
            `${getFormattedNumber(main_balance + bonus)} Ks`
          )}
        </MyWalletLabel>
        {can_exit_check
          ? <ReloadIcon onClick={checkExit} />
          : <ArrowRightLine width="15px" height="15px" />
        }
      </MyWalletContainer>
      <WalletButton
        onClick={handleTopUpClicked}
        label={t("wallet.walletTopUp")}
        icon={<AddCircleFill />}
      />
      <WalletButton
        onClick={handleWithdrawClicked}
        label={t("wallet.walletWithdraw")}
        icon={<UploadFill />}
      />
    </RootContainer>
  );
};

export default MyWallet;
